import { useDispatch, useSelector } from 'react-redux';
import { isAppReadySelector } from '../../../../../../features/bootstrapSlice';
import { allInvitationGroupsSelector } from '../../../../../../features/apiFeatures/invitationGroupSlice';
import { allInvitationKeysSelector } from '../../../../../../features/apiFeatures/invitationKeySlice';
import { useEffect } from 'react';
import { getAllInvitationGroupsInitialize } from '../../../../../../features/actions/api';

export const useData = () => {
  const dispatch = useDispatch();

  const isAppReady = useSelector(isAppReadySelector);
  const allInvitationGroups = useSelector(allInvitationGroupsSelector);
  const allInvitationKeys = useSelector(allInvitationKeysSelector);

  useEffect(() => {
    if (isAppReady) {
      dispatch(getAllInvitationGroupsInitialize());
    }
  }, [dispatch, isAppReady]);

  return {
    allInvitationGroups,
    allInvitationKeys,
  };
};
